import { createFileRoute, Link } from "@tanstack/react-router";

import { FormattedMessage } from "react-intl";

import SlidingSection from "@/components/LandingPage/SlidingSection.tsx";
import Features from "@/components/LandingPage/Features.tsx";
import Mission from "@/components/LandingPage/Mission.tsx";
import Contact from "@/components/LandingPage/Contact.tsx";

import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useLocale } from "@/contexts/IntlContext";
import logoHamd from "@/assets/new-logo.svg";
import { FaChevronRight } from "react-icons/fa6";
import MainContent from "@/components/LandingPage/MainContent";
import newoverlay from "@/assets/landing-page/new-overlay.png";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { locale } = useLocale();


  return (
    <div
      className="min-h-screen"
      style={{
        backgroundImage: `url(${newoverlay})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Header */}
      <header className="flex justify-between items-center px-[20px] lg:px-4 py-3 sm:px-8">
        <img
          src={logoHamd}
          alt="HAMD Logo"
          className="h-[25px] sm:h-14 lg:h-18"
        />
        <div className="flex items-center gap-5">
          <Link to={"/welcome"}>
            <button className="flex items-center gap-1 bg-primary text-white px-2 py-1 sm-4 lg:px-6 lg:py-3 rounded-md text-micro sm:text-body lg:text-small  shadow-md">
              <span className="">
                <FormattedMessage id="header.openApp" />
              </span>
              <FaChevronRight
                size={15}
                className={` ${locale === "ar" ? "rotate-180" : ""}`}
              />
            </button>
          </Link>

          <LanguageSwitcher className="bg-primary text-white min-w-[auto] w-7 h-6 px-[4px] sm:w-12 sm:h-8 lg:w-14 lg:h-11 sm:px-2 rounded-[12px] " />
        </div>
      </header>

      {/* Main Hero Content */}
      <MainContent />

      {/* Second Section - Support Features */}
      <Features />

      {/* Third Section - Sliding Exercises */}
      <SlidingSection />

      {/* Fourth Section - Mission */}
      <Mission />

      {/* Fifth Section - Contact */}
      <Contact />
    </div>
  );
}
